export default __webpack_public_path__ + "static/media/cover.ddfc688e.jpg";